import axios from 'ggApp/utils/requests';

// eslint-disable-next-line import/prefer-default-export
export function confirmPayPalPaymentMethod(orderNumber, data) {
    return axios.post(`/orders/${orderNumber}/paypal_confirm`, data);
}
